export default __webpack_public_path__ + "static/media/AIRE.b8161865.png";